import TicketHttp from "../../ticketHttp";

class TheatreServices {
  static listTheatres(params = {}) { return TicketHttp.get('/theatres', params); }
  static getTheatres(params = {}) { return TicketHttp.get('/theatres', params); }
  static createTheatre(data) { return TicketHttp.post('/theatres', data); }
  static updateTheatre(id, data) { return TicketHttp.update(`/theatres/${id}`, data); }
}

export default TheatreServices;
